/**
 * description:
 * Standalone page for the Ate/Kuya program
 */

import { Box, Typography } from "@mui/material";
import { mustard } from "../../../styles.tsx";
import FamShowcase from "./FamShowcase";
import MingleWeekTimeline from "./MingleWeekTimeline";
import PageHero from "../../../utils/PageHero";
import ateKuyaHero from "../../../pictures/Hero/AteKuyaHero.svg";
import introPicture from "../../../pictures/AteKuya/intro.jpg";

function AteKuyaPage() {
  return (
    <>
      <PageHero
        image={ateKuyaHero}
        viewBoxWidth={830}
        viewBoxHeight={350}
        cropHeight={350}
        bandColor="#F2C94C"
        accessibleTitle="Ate Kuya"
        width={{ xs: "94vw", sm: "620px", md: "649px" }}
        imageScale={0.85}
      />

      <Box sx={{ bgcolor: "primary.main", px: { xs: "20px", md: "48px" }, py: { xs: "48px", md: "80px" } }}>
        <Box sx={{ maxWidth: "1200px", mx: "auto" }}>
          <Typography variant="h2" sx={{ color: mustard, mb: "32px" }}>
            What is Ate/Kuya?
          </Typography>
          <Box
            sx={{
              bgcolor: "background.default",
              borderRadius: "4px",
              p: { xs: "20px", md: "32px" },
              boxShadow: "8px 8px 0 #ad5d4e",
              display: "grid",
              gridTemplateColumns: { xs: "1fr", md: "240px 1fr" },
              gap: { xs: "20px", md: "36px" },
              alignItems: "center",
            }}
          >
            <Box
              component="img"
              src={introPicture}
              alt="Ate/Kuya bigs and littles"
              sx={{
                width: "100%",
                aspectRatio: "16 / 9",
                objectFit: "cover",
                borderRadius: "4px",
                display: "block",
              }}
            />
            <Box>
              <Typography variant="body1" sx={{ color: "#4a4a4a", fontSize: { xs: "1.05rem", md: "1.15rem" } }}>
                In Tagalog, Kuya means "older brother" and Ate means "older sister" these words are used to show respect for someone who is older than you. For us, it also means finding a family who guides you :)
              </Typography>
              <Typography variant="body1" sx={{ color: "#4a4a4a", fontSize: { xs: "1.05rem", md: "1.15rem" }, mt: "16px" }}>
                Ate/Kuya pairs you with a big who can be a mentor and best friend. You'll get to know more people across FASA, make super fun memories, and join a fam that supports you through your time at Virginia Tech.
              </Typography>
              <Typography variant="body1" sx={{ color: "#4a4a4a", fontSize: { xs: "1.05rem", md: "1.15rem" }, mt: "16px" }}>
                Be sure you qualify for Ate/Kuya by:
              </Typography>
              <Box
                component="ul"
                sx={{
                  color: "#4a4a4a",
                  fontSize: { xs: "1.05rem", md: "1.15rem" },
                  m: 0,
                  mt: "8px",
                  pl: "24px",
                  "& li": { mb: "6px" },
                  "& li:last-of-type": { mb: 0 },
                }}
              >
                <li>Paying FASA membership dues</li>
                <li>Attending an anti-hazing workshop</li>
                <li>Attending SPEED DATING and TWO other events during mingle week</li>
                <li>Filling out the application and preference sheet by Sept 26 @ 12 PM AT THE LATEST</li>
                <li>Optional: create a slide showcasing your personality to potential bigs/littles!</li>
              </Box>
            </Box>
          </Box>
        </Box>
      </Box>

      <Box sx={{ bgcolor: "background.default", px: { xs: "20px", md: "48px" }, py: { xs: "48px", md: "80px" } }}>
        <Box sx={{ maxWidth: "1200px", mx: "auto" }}>
          <Typography variant="h2" sx={{ mb: "16px" }}>
            Mingle Week
          </Typography>
          <Typography variant="body1" sx={{ fontSize: { xs: "1.05rem", md: "1.15rem" }, maxWidth: "760px", mb: "32px" }}>
            Before reveal, we have a full week of events so Bigs and Littles can meet each other. Come to as many as you can as the more people you talk to, the more likely you'll find your perfect big or little! Check out the schedule below:
          </Typography>
          <MingleWeekTimeline />
        </Box>
      </Box>

      <Box sx={{ bgcolor: "background.default", px: { xs: "20px", md: "48px" }, py: { xs: "48px", md: "80px" } }}>
        <Box sx={{ maxWidth: "1200px", mx: "auto" }}>
          <Typography variant="h2" sx={{ mb: "32px" }}>
            Our Fams
          </Typography>
          <FamShowcase />
        </Box>
      </Box>

      <Box sx={{ bgcolor: mustard, px: { xs: "20px", md: "48px" }, py: { xs: "48px", md: "80px" } }}>
        <Box sx={{ maxWidth: "1200px", mx: "auto" }}>
          <Typography variant="h2" sx={{ color: "primary.main", mb: "4px" }}>
            Questions?
          </Typography>
          <Typography
            sx={{
              fontFamily: "Anton, sans-serif",
              textTransform: "uppercase",
              letterSpacing: "1px",
              color: "secondary.main",
              mb: "32px",
              fontSize: { xs: "1.1rem", md: "1.4rem" },
            }}
          >
            Ask Our Hospitality Chairs!
          </Typography>
          <Box
            sx={{
              display: "grid",
              gridTemplateColumns: { xs: "1fr", sm: "1fr 1fr" },
              gap: { xs: "24px", sm: "48px" },
              maxWidth: "640px",
              mx: "auto",
              textAlign: "center",
            }}
          >
            <Box>
              <Typography variant="body1" sx={{ fontWeight: 700, fontSize: { xs: "1.15rem", md: "1.3rem" } }}>Janis Lingat</Typography>
              <Typography variant="body1" sx={{ fontSize: { xs: "1.15rem", md: "1.3rem" } }}>janislingat@vt.edu</Typography>
            </Box>
            <Box>
              <Typography variant="body1" sx={{ fontWeight: 700, fontSize: { xs: "1.15rem", md: "1.3rem" } }}>Bianca Rivera</Typography>
              <Typography variant="body1" sx={{ fontSize: { xs: "1.15rem", md: "1.3rem" } }}>brivera56@vt.edu</Typography>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
}

export default AteKuyaPage;